import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import ModalWizard from "./ModalWizard";
import ModalSignTermsOfUse from "./ModalSignTermsOfUse";

const TermsAndWizardGuard = ({ children }) => {
  const { termsOfUseVersion, auth, brand, isAdminUser } = useAuth();
  const [showSignTerm, setShowSignTerm] = useState(false);
  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    if (
      auth &&
      auth.user &&
      !auth.user.custom?.doctorConsentAuthorizeVersion &&
      !auth.offline &&
      auth.user.role !== "administrator" &&
      !isAdminUser
    ) {
      setShowWizard(true);
    } else if (
      auth &&
      !auth.offline &&
      auth.user &&
      auth.user.role !== "administrator" &&
      !isAdminUser &&
      (!auth.user.custom?.doctorConsentAuthorizeVersion ||
        auth.user.custom?.doctorConsentAuthorizeVersion < (termsOfUseVersion[brand || "default"] ?? termsOfUseVersion.default))
    ) {
      setShowSignTerm(true);
    }
    // eslint-disable-next-line
  }, [auth]);

  if (showWizard) {
    return <ModalWizard close={() => setShowWizard(false)} />;
  }

  if (showSignTerm) {
    return <ModalSignTermsOfUse setShowSignTerm={setShowSignTerm} />;
  }

  return children;
};

export default TermsAndWizardGuard;
